export default __webpack_public_path__ + "static/media/Arrow-grey.e793343c.svg";